import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { PolicyRoutes, policyRoutesInfo, preFormRoutes, utilityRoutes } from "../../routing/routes.config";
import useApiClient from "../useApiClient";
import useHasValidSession from "../useHasValidSession";

export const webChatDisallowPages = [
  ...utilityRoutes,
  ...preFormRoutes,
  policyRoutesInfo[PolicyRoutes.Confirmation],
].map((route) => route.path.toLowerCase());

export const useGetWebChatInformation = () => {
  const client = useApiClient();
  const location = useLocation();
  const hasValidSession = useHasValidSession();

  const [pointOfContactId, setPointOfContactId] = useState("");
  const [shouldRenderWebChat, setShouldRenderWebChat] = useState(false);
  const [crmId, setCrmId] = useState("");

  const currentLocation = location.pathname.toLowerCase();
  const shouldGetWebChatInformation = hasValidSession && !webChatDisallowPages.includes(currentLocation);

  useEffect(() => {
    let isCancelled = false;

    const getWebChatId = async () => {
      try {
        if (!isCancelled) {
          if (shouldGetWebChatInformation) {
            const { result } = await client.getWebChatContactId();
            setPointOfContactId(result.pointOfContactId ?? "");
            setCrmId(result.crmId ?? "");
            setShouldRenderWebChat(true);
          } else {
            setShouldRenderWebChat(false);
          }
        }
      } catch {
        setPointOfContactId("");
        setShouldRenderWebChat(false);
      }
    };

    getWebChatId();

    return () => {
      isCancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentLocation, shouldGetWebChatInformation]);
  // CurrentLocation is a required dep otherwise will not check agent availability when user navigates from page to page

  return { pointOfContactId, crmId, shouldRender: shouldRenderWebChat };
};

export default useGetWebChatInformation;
